module.exports = __webpack_public_path__ + "static/media/znakomstva.a978137a.png";